import "./EditPartnerUser/EditPartnerUserComponent";
import "./PartnerUserDetails.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import PartnerUserDetailsComponentController from "./PartnerUserDetailsComponentController";

export default class PartnerUserDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            partnerId: "<",
            partnerUserId: "<",
        };
        this.controller = PartnerUserDetailsComponentController;
        this.templateUrl = "/App/Components/PartnerUser/Details/PartnerUserDetails.html";
    }
}

module("mmManagePortal").component("mmPartnerUserDetails", new PartnerUserDetailsComponent());
